export default __webpack_public_path__ + "static/media/full_star.7bef184c.svg";